import React from 'react';
import SalesRepForm from '../components/SalesRepForm';
import Footer from '../components/Footer';

const SalesRepPage = () => {
  const pageStyle = {
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    padding: '3rem 1rem'
  };

  const headerStyle = {
    textAlign: 'center',
    maxWidth: '800px',
    margin: '0 auto 2rem',
    padding: '0 1rem'
  };

  const announcementStyle = {
    maxWidth: '800px',
    margin: '0 auto 3rem',
    padding: '2rem',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 0 20px rgba(0,0,0,0.1)',
    textAlign: 'center'
  };

  const highlightStyle = {
    color: '#28a745',
    fontWeight: '700'
  };

  return (
    <div style={pageStyle}>
      <div style={headerStyle}>
        <h1 className="mb-3" style={{ color: '#333', fontSize: '2.5rem' }}>Join Our Sales Team</h1>
        <p className="lead text-muted">
          Become a WeedHurry Sales Representative and earn commission by connecting dispensaries to our platform.
        </p>
      </div>

      <div style={announcementStyle}>
        <h2 style={{ color: '#2d3748', marginBottom: '1rem' }}>Amazing Commission Opportunity</h2>
        <p style={{ fontSize: '1.2rem', marginBottom: '1.5rem' }}>
          Earn <span style={highlightStyle}>$100 immediately</span> for each dispensary you sign up, plus <span style={highlightStyle}>50% commission every month</span> for 2 years!
        </p>
        <p style={{ fontSize: '1.1rem' }}>
          Whether you're connected to the industry or just have a great network, this is an excellent opportunity to earn significant income while helping businesses grow.
        </p>
      </div>

      <SalesRepForm />
      <Footer />
    </div>
  );
};

export default SalesRepPage;